import styled from "styled-components"
import LinearProgress from "@mui/material/LinearProgress";

export const CustomAside = styled.aside`
position: fixed;
height: 95%;
width: 320px;
background-color: var(--gray-1);
display: flex;
flex-direction: column;
align-items: center;
justify-content: space-between;
overflow-y: auto;

section{
    width: 100%;
    height: 250px;
    background-color: var(--gray-2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    padding: 20px 0;
    margin-bottom: 20px;
}

section>p{
    color: var(--text-color);
}

img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
}

    @media (max-width: 1024px){
        display: none;
    }
`
export const Container = styled.div`
width: 70%;
margin-bottom: 20px;
border-bottom: 1px solid var(--divider-color);
padding-bottom: 10px;

h4{
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
}

h4>span{
    color: var(--text-color);
    font-weight: 500;
}

circle{
    color: var(--secundary-color);
}

.MuiBox-root{
    width: 80px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.MuiBox-root>p{
    position: absolute;
    top: 12px;
    left: 25px;
    width: 31px;
    text-align: center;
    font-size: 12px;
}

h5{
    margin: 10px 0
}

@media (max-width: 1024px){
    margin-bottom:10px;
}

`

export const Div = styled.div`
display: flex;
justify-content: space-evenly;
`

export const CustomLinearProgress = styled(LinearProgress)`
width: 100%;

>span{
background-color: var(--secundary-color);
}
`
export const LinearProgressDiv = styled.div`
display: flex;
flex-direction: column;
align-items: center;
margin-bottom: 10px;

.MuiLinearProgress-root{
    background-color: var(--primary-color);
}

>h5{
    margin-top: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
}
`

export const Footer = styled.div`
    display: flex;
    height: 70px;
    width: 100%;
    background-color: var(--gray-2);
    justify-content: space-evenly;
    align-items: center;

    a{
        height: 25px;
    }

    svg{
        color: var(--text-color);
        width: 25px;
        height: 25px;
        cursor: pointer;
    }

    svg:hover{
        color: var(--white-color);
    }
`

